import GeneralProduct from '~/Api/Product/Product';
import { ReferencePrice } from '~/Api/User/ProductGroup/LtMaxPrice/ReferencePrice';

export class Product {
	constructor(
		public allowsEmptyCalculator: { exFactory: boolean },
		public packageSizeForCalculation: number | null,
		public packageSizeForSingleUnit: number | null,
		public dosageStrengthForCalculation: number | null,
		public product: GeneralProduct,
		public referenceDataSource: boolean,
		public referencePrices: ReferencePrice[],
		public selectable: boolean,
		public selected: boolean,
		public singleUnitPackageSize: boolean
	) {}

	findSelectedReferencePrice(): ReferencePrice | null {
		return this.referencePrices.find((price) => price.calculatedPrice.selected) ?? null;
	}
}
